import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import BadgeStyle from "components/badges/Badge.module.scss";

export const Emerald = ({size, id, className}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 64 64";
  _attributes.width = _attributes.height = size || 64;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(BadgeStyle["badge"], className);
  } else {
    _attributes.className = BadgeStyle["badge"];
  }

  return (
    <svg {..._attributes}>
      <rect x={0} y={0} width={64} height={64} className={BadgeStyle["badge__canvas"]}/>
      <g>
        <g>
          <path d="M32.024,18.366l0,-14.366l-8.485,18.004l8.485,-3.638Z" className={BadgeStyle["emerald__fill1"]} />
          <path d="M23.537,22.004l-12.493,9.992l10.48,0l2.013,-9.992Z" className={BadgeStyle["emerald__fill1"]} />
          <path d="M32.024,4l-20.98,27.996l12.493,-9.991l8.487,-18.005Z" className={BadgeStyle["emerald__fill2"]} />
          <path d="M23.538,22.004l-2.015,9.992l10.498,-13.63l-8.483,3.638Z" className={BadgeStyle["emerald__fill3"]} />
          <path d="M23.538,41.987l8.485,3.64l-10.499,-13.63l2.014,9.99Z" className={BadgeStyle["emerald__fill4"]} />
          <path d="M23.539,41.987l8.485,18.003l0,-14.364l-8.485,-3.639Z" className={BadgeStyle["emerald__fill5"]} />
          <path d="M11.044,32l20.98,27.996l-8.487,-18.009l-12.493,-9.987Z" className={BadgeStyle["emerald__fill6"]} />
          <path d="M21.525,32l-10.481,0l12.493,9.987l-2.012,-9.987Z" className={BadgeStyle["emerald__fill3"]} />
          <path d="M32.024,45.626l0,14.364l8.485,-18.005l-8.485,3.641Z" className={BadgeStyle["emerald__fill6"]} />
          <path d="M40.508,41.987l12.496,-9.987l-10.481,0l-2.015,9.987Z" className={BadgeStyle["emerald__fill6"]} />
          <path d="M40.508,41.987l-8.484,18.009l20.98,-27.996l-12.496,9.987Z" className={BadgeStyle["emerald__fill5"]} />
          <path d="M32.024,45.627l8.485,-3.64l2.015,-9.991l-10.5,13.631Z" className={BadgeStyle["emerald__fill7"]} />
          <path d="M40.508,22.004l-8.485,-3.639l10.499,13.63l-2.014,-9.991Z" className={BadgeStyle["emerald__fill3"]} />
          <path d="M40.508,22.005l-8.485,-18.004l0,14.366l8.485,3.638Z" className={BadgeStyle["emerald__fill2"]} />
          <path d="M53.004,31.996l-20.98,-27.996l8.485,18.004l12.495,9.992Z" className={BadgeStyle["emerald__fill4"]} />
          <path d="M42.523,31.996l10.481,0l-12.496,-9.992l2.015,9.992Z" className={BadgeStyle["emerald__fill7"]} />
          <path d="M39.49,28.059l-7.466,-9.693l-10.499,13.63l2.594,3.368c5.974,0.437 12.196,-1.998 15.371,-7.305Z" className={BadgeStyle["emerald__fill2"]}/>
          <path d="M42.524,31.996l-3.075,-3.999c-3.174,5.307 -9.486,7.629 -15.461,7.193l8.037,10.433l10.499,-13.627Z" className={BadgeStyle["emerald__fill1"]}/>
        </g>
        <path d="M43.069,32.383l5.753,-0.546l-5.753,-0.547l-0.546,-5.753l-0.547,5.753l-5.753,0.547l5.753,0.546l0.547,5.754l0.546,-5.754Z" className={BadgeStyle["emerald__white"]} />
      </g>
    </svg>
  );
};

Emerald.defaultProps = {
  size: 64,
  className: "",
  id: ""
};

Emerald.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
